import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Portfolio from '../components/sections/Portfolio';
import Contact from '../components/sections/Contact';
import Footer from '../components/sections/Footer';

const Home = () => {
    const location = useLocation();

    const scrollToProjects = () => {
        const projectsSection = document.getElementById('projects');
        if (projectsSection) {
            projectsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        // Handle scroll from navigation state (e.g., from other pages)
        if (location.state && location.state.scrollTo) {
            const section = document.getElementById(location.state.scrollTo);
            if (section) {
                // Short delay to ensure rendering
                setTimeout(() => {
                    section.scrollIntoView({ behavior: 'smooth' });
                    // Optional: Clear state to prevent scroll on refresh - typically handled by history stack
                }, 100);
            }
        }
    }, [location]);

    return (
        <div className="min-h-screen bg-white">
            <Navbar onProjectsClick={scrollToProjects} />
            <Hero />
            <About />
            <Services />
            <Portfolio />
            <Contact />
            <Footer />
        </div>
    );
};

export default Home;
